<template>
    <div class="nav">
        <el-menu class="nav-list" mode="horizontal" router>
            <el-menu-item class="logo">
                <img src="../assets/image/logo.png" alt=""/>
                <span>{{ $t('nav.vision') }}</span>
            </el-menu-item>
            <el-menu-item index="/home">{{ $t('nav.walk') }}</el-menu-item>
            <el-submenu index="">
                <template slot="title">{{ $t('nav.product') }}</template>
                <el-menu-item index="/wms">WMS</el-menu-item>
                <el-menu-item index="/mes">MES</el-menu-item>
                <el-menu-item index="/npm">NPM</el-menu-item>
                <el-menu-item index="iiot">IIoT</el-menu-item>
                <el-menu-item index="npi">NPI</el-menu-item>
            </el-submenu>
            <el-menu-item index="/customer">{{ $t('nav.case') }}</el-menu-item>
            <el-menu-item index="/company">{{ $t('nav.introduce') }}</el-menu-item>
            <el-menu-item index="/talent">{{ $t('nav.recruitment') }}</el-menu-item>
            <el-menu-item index="/contact">{{ $t('nav.contact') }}</el-menu-item>
            <span class="item">
        <!-- 中/EN -->
      </span>
        </el-menu>
        <div>
            <router-view></router-view>
        </div>
        <!-- 地址栏 -->
        <div class="address">
            <div class="etao-left">
                <span>深圳一道创新技术有限公司</span>
                <div>{{ $t('nav.telephone') }}：400-606-2838</div>
                <div>{{ $t('nav.phone') }}：134-1859-5696</div>
                <div>{{ $t('nav.email') }}：sales@etao-it.com</div>
                <div>
                    <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备16026907号</a>
                </div>
                <div>
                    <span class="police"></span>
                    <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030702004685"
                       target="_blank">粤公网安备44030702004685号</a>
                </div>
                <div class="contact">
                    <span>{{ $t('nav.product') }}</span>
                    <u @click="toWms">WMS</u>
                    <u @click="toMes">MES</u>
                    <u @click="toNpm">NPM</u>
                    <u @click="toIiot">IIoT</u>
                    <u @click="toNpi">NPl</u>
                </div>
            </div>
            <div class="etao-right">
                <div>深圳：广东省深圳市龙岗区坂田街道天安云谷6栋东座506</div>
                <span>苏州：江苏省苏州市工业园区科营路中新生态大厦1104</span>
            </div>
            <div class="map">
                <baidu-map class="bmView"
                           :scroll-wheel-zoom="true"
                           :center="location"
                           :zoom="zoom"

                           ak="5viza4iNZL9A2FruB0mpaLjQmenITEfr">
                    <bm-marker :position="{lng: location.lng, lat: location.lat}" name="">
                    </bm-marker>
                </baidu-map>
            </div>
        </div>
    </div>

</template>
<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue'

export default {
    components: {
        BaiduMap,
        BmMarker,
    },
    name: "",
    data() {
        return {
            location: {
                lng: 114.074075,
                lat: 22.666005,
            },
            zoom: 17,
            zh: true
        };
    },

    methods: {
        // 点击切换语言
        //   change() {
        //   if (this.$i18n.locale === "en") {
        //     this.$i18n.locale = "zh";
        //   } else {
        //     this.$i18n.locale = "en";
        //   }
        // },
        toHome() {
            this.$router.push("/home");
        },
        toWms() {
            this.$router.push("/wms");
        },
        toNpm() {
            this.$router.push("/npm");
        },
        toIiot() {
            this.$router.push("/IIot");
        },
        toNpi() {
            this.$router.push("/npi");
        },
        toMes() {
            this.$router.push("/mes");
        },
    },
};
</script>
<style scoped>
/* 导航栏样式 */
.nav-list {
    width: 100%;
    position: fixed;
    z-index: 100;
    display: flex;
    justify-content: space-between;
    background-color: #f7f7f7;
}

.el-menu--horizontal > .el-menu-item {
    font-size: 14px;
    height: 80px;
    line-height: 80px;
    color: #000;
    margin: 0 10px;
}

.logo {
    padding-left: 140px;
    flex: 1;
}

.logo > img {
    margin-right: 20px;
}

.item {
    line-height: 80px;
    margin-right: 150px;
    margin-left: 20px;
}

.el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid red;
}

/* 地址栏样式 */
.address {
    width: 100%;
    height: 350px;
    background-color: #f4f4f4;
    display: flex;
    justify-content: center;
    position: relative;
}

.etao-left {
    margin-top: 40px;
    margin-left: 150px;
}

.etao-left > span {
    margin-bottom: 40px;
    display: block;
    font-weight: 800;
}

.etao-left > div {
    margin-bottom: 15px;
    color: #6e6e6e;
}

.etao-left .contact {
    margin-top: 50px;
}

.contact > span {
    margin-right: 40px;
    color: #000;
    font-weight: 600;
}

.contact > u {
    margin-right: 30px;
    color: #6e6e6e;
}

u:hover {
    cursor: pointer;
}

.etao-right {
    color: #6e6e6e;
}

.etao-right > div {
    margin-top: 160px;
    margin-bottom: 20px;
}

.address .map {
    flex: 1;
}

.address .map > .bmView {
    width: 300px;
    height: 200px;
    line-height: 350px;
    margin-top: 75px;
}

.markerPoint {
    left: 0;
    top: 0;
}

.police {
    padding: 10px;
    margin-right: 5px;
    background: url(../assets/police.png) center / 20px no-repeat;
}
</style>
<style>
.el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 80px !important;
    line-height: 80px !important;
    color: #000 !important;
    margin: 0 10px;
}

.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: 2px solid red !important;
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
    background-color: #f7f7f7 !important;
}

.el-menu--popup-bottom-start {
    min-width: 106px !important;
    margin: 0 !important;
    margin-left: 14px !important;
    padding: 0 !important;
    text-align: center !important;
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
    border-bottom: 1px solid #ccc !important;
    height: 45px !important;
    line-height: 45px !important;
    font-size: 14px !important;
}

.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    background-color: #f7f7f7 !important;
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
    background-color: #f7f7f7 !important;
}
</style>

